module.exports = __webpack_public_path__ + "static/img/explore-back.892ce1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/explore-back.png
// module id = v9Ro
// module chunks = 1